const currentConfiguration = require('./currentConfiguration');

module.exports = {
  getUiPlatform: () => {
    return currentConfiguration;
  },
};
